export default __webpack_public_path__ + "static/media/cameraSpeaker.98ed336b.png";